<template>
  <div class="col-4 narrow results">
    <catalog-results-result v-for="result in results.data" :key="result.id" :record="result" :isExpandedDefaultState="isExpandedResult" :genre="genre" :song="song"></catalog-results-result>
  </div>
</template>

<script>
import CatalogResultsResult from './CatalogResultsResult.vue';

export default {
  props: ['results', 'isExpandedResult', 'genre', 'song'],
  
  components: {
    'catalog-results-result': CatalogResultsResult
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/vue/components/CatalogResultsResults.vue